// ONYX-CUSTOM: accordion behaviour for bundle part specifications
if (!customElements.get('bundle-specs')) {
  customElements.define(
    'bundle-specs',
    class BundleSpecs extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const header = event.target.closest('.bundle-specs__header');
        if (!header || !this.contains(header)) return;

        const part = header.closest('.bundle-specs__part');
        const shouldOpen = !part.classList.contains('is-open');

        this.querySelectorAll('.bundle-specs__part').forEach((item) => this.setOpen(item, false));
        if (shouldOpen) this.setOpen(part, true);
      }

      setOpen(part, isOpen) {
        part.classList.toggle('is-open', isOpen);
        part.querySelector('.bundle-specs__header').setAttribute('aria-expanded', String(isOpen));
        part.querySelector('.bundle-specs__panel').toggleAttribute('inert', !isOpen);
      }
    }
  );
}
